import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import FERPA from '../../../../../components/FERPA/FerpaComponent';
import { Col, Row } from 'react-bootstrap';
import {
  useGetAllCourseListMutation,
  useGetClassesMutation,
  useGetAllCustomCoursesMutation,
} from '../../../../../features/authentication/authApiSlice';
import {
  useGetDropdownValuesMutation,
  useUpdateCourseIdMutation,
  useUpdateClassIdMutation
} from '../../../../../features/authentication/persistApiSlice';
import DropDown from '../../../../../components/DropDown';
import { useClassManagementContext } from '../utils/classManagementContext';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

const HeaderBar = ({ showCourseHelpIcon , showAllCourses }) => {

  const [getAllCourses] = useGetAllCourseListMutation();
  const [getAllClasses] = useGetClassesMutation();
  const [getAllCustomCourses] = useGetAllCustomCoursesMutation();
  const [getDropdownPersistValues] = useGetDropdownValuesMutation();
  const [persistCourseId] = useUpdateCourseIdMutation();
  const [persistClassId] = useUpdateClassIdMutation();
  const [courses, setCourses] = useState([]);
  const [customCourses, setCustomCourses] = useState([]);
  const { classes, setClasses, selectedClassId, setSelectedClassId, selectedCourseId, setSelectedCourseId, selectedCustomCourseId, setSelectedCustomCourseId } = useClassManagementContext();
  const [className, setClassName] = useState('');
  let { Id } = useParams();
  const navigate = useNavigate();

  Id = !selectedClassId ? Id : selectedClassId;

  async function loadClasses() {
    var classes = await getAllClasses().unwrap();
    localStorage.setItem('classes', JSON.stringify(classes));

    setClasses([
      ...classes.map((item) => ({
        name: item.className,
        id: item.classID,
        coteacherName: item.coTeacherClass ? item.teacherName : '',
        coTeacherClass: item.coTeacherClass
      }))
    ]);
    if (classes.length > 0)
      setClassName(classes[0].className);
  }

  const handleClassChange = async (e) => {
    setSelectedClassId(parseInt(e.target.value));
    await persistClassId(parseInt(e.target.value));
    const selectedClass = classes.filter(item => item.id == parseInt(e.target.value));
    if (selectedClass.length > 0)
      setClassName(selectedClass[0].name);
  };

  const handleCourseChange = async (e) => {
    setSelectedCourseId(parseInt(e.target.value));
    await persistCourseId(parseInt(e.target.value));
  };

  const handleCustomCourseChange = (e) => {
    setSelectedCustomCourseId(parseInt(e.target.value));
  };

  useEffect(() => {
    const fetchDropDownData = async () => {
      let courses = await getAllCourses().unwrap();
      if (courses)
      {
        if(showAllCourses)
        {
          const obj = {
            id: -1,
            name: 'All Course'
          };
          courses = [obj, ...courses];
        }
        setCourses(courses);
      }

      let classes = localStorage.getItem('classes');
      if (classes) {
        classes = JSON.parse(classes);
        setClasses([
          ...classes.map((item) => ({
            name: item.className,
            id: item.classID,
            coteacherName: item.coTeacherClass ? item.teacherName : '',
            coTeacherClass: item.coTeacherClass
          }))
        ]);
        const selectedClass = classes.filter(item => item.classID == Id);
        if (selectedClass.length > 0)
          setClassName(selectedClass[0].className);
      } else {
        loadClasses();
      }

      var customCourses = await getAllCustomCourses().unwrap();
      setCustomCourses(customCourses);
      if (customCourses.length > 0)
        setSelectedCustomCourseId(customCourses[0].id);

      var persistValues = await getDropdownPersistValues().unwrap();
      setSelectedCourseId(persistValues.courseId == -1 ? courses[0].id : persistValues.courseId);
      setSelectedClassId(Id);
    };

    fetchDropDownData();
  }, []);

  return (
    <div className="white-card">
      <div className="row align-items-center mb-3">
        <div className="col-md-6">
          <h2 className="primary-title mb-md-0">
            <span className='fw-medium'>Class Details:</span> <span className='fw-normal'>{className}</span>
          </h2>
        </div>
        <div className="col-md-6 d-flex gap-3 flex-column flex-sm-row  justify-content-between justify-content-md-end align-items-center">
          <div className="col-xl-1 text-xl-end ps-xl-0 mt-3 mt-xl-0 mr-2">
            <FERPA />
          </div>
          <button
            onClick={() => navigate('/classes')}
            className="btn btn-castleWhite btn-width">
            Back
          </button>
        </div>
      </div>
      <Row>
        <Col md={4}>
          <DropDown
            key='classSelect'
            label="Class"
            value={classes}
            onChangeHandler={(e) => handleClassChange(e)}
            selectedValue={selectedClassId}
            dropDownName={'Class'}
            description={true}
          />
        </Col>
        <Col md={4}>
          <DropDown
            key='courseSelect'
            label="Course"
            value={courses}
            onChangeHandler={(e) => handleCourseChange(e)}
            selectedValue={selectedCourseId}
            dropDownName={'Course'}
            isLableInfo={showCourseHelpIcon}
            tooltipContent={'Note that the Course selection is used for all tabs except the Class Management tab.'}
          />

        </Col>
        <Col md={4}>
          {selectedCourseId === 255 && <DropDown
            key='customCourseSelect'
            label="Custom Course"
            value={customCourses}
            onChangeHandler={(e) => handleCustomCourseChange(e)}
            selectedValue={selectedCustomCourseId}
            dropDownName={'CustomCourse'}
          />
          }
        </Col>
      </Row>
    </div>
  );
};

HeaderBar.propTypes = {
  showCourseHelpIcon: PropTypes.bool,
  showAllCourses: PropTypes.bool
};
export default HeaderBar;